import topbar from './topbar';
import sidebar from './sidebar';

export default {
  topbar,
  sidebar
}



// WEBPACK FOOTER //
// ./src/locales/no/layout/navigation/index.js